import { useState } from "react";
import States from "../../../../utils/Constants"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import Table from "../../Shared/Table";
import { useSelector } from "react-redux";
import DatePicker from "../../../General/DatePicker";
import FormValidator from "../../../../utils/FormValidator";
import { enumUtil } from "../../../../utils/Enum";
import NotificationHandler from "../../../../utils/NotificationHandler";
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest";
import Loader from "../../../shared/Loader/Loader";

const DeactiveUser = (props) => {

    console.log(props?.DeActiveData, 'DeActiveData');

    const API_URL = enumUtil.controller.General
    let DeactiveUser_model = {
        DeActiveDate: '',
        DeActiveComments: '',
    }
    let valModal = {}
    let ValidationModal = {
        DeactiveDateVal: "",
        FullDescriptionVal: "",
    }
    const [deactiveUserValidationModal, setDeactiveUserValidationModal] = useState(ValidationModal)
    const [mainDeactiveUser, setMainDeactiveModel] = useState(DeactiveUser_model)
    const [saveDeactiveUser, setSaveDeactiveUser] = useState({})
    const [isLoading, setIsLoading] = useState(false);


    const PatientValidation = async () => {
        let ValidationModal = {

            DeactiveDateVal: FormValidator(
                mainDeactiveUser.DeActiveDate,
                enumUtil.enumValidationType.Required,
                'Date',
            ),

            FullDescriptionVal: FormValidator(
                mainDeactiveUser.DeActiveComments,
                enumUtil.enumValidationType.Required,
                'FullDescription'
            ),

        }
        await setDeactiveUserValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainDeactiveUser };
        let saveModal = { ...saveDeactiveUser }
        modal[type] = FormatedDate
        setMainDeactiveModel(modal)
        for (var property in DeactiveUser_model) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setSaveDeactiveUser(saveModal)
    }
    const handleChangeInput = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainDeactiveUser };
        let saveModal = { ...saveDeactiveUser }
        modal[name] = value
        setMainDeactiveModel(modal)
        for (var property in DeactiveUser_model) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSaveDeactiveUser(saveModal)
    }
    console.log(saveDeactiveUser, 'saveDeactiveUser');


    const handleDeactiveSave = async () => {
        await PatientValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        }
        else {

            let saveModal = {
                TableName: enumUtil.enumAPITableName.GetUserSalt,
                ID: props.userID + "",
                Data: { ...saveDeactiveUser, UserStatus: "Deactivated" },

            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/DeActiveUser", 'post', saveModal).then((response) => {
                setIsLoading(false)
                setMainDeactiveModel(DeactiveUser_model)
                props?.FindByID(props.userID)
                props?.GridApi()
                NotificationHandler('User Successfully DeActived!', enumUtil.enumtoaster.success)

            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }

    const handleActivateSave = async () => {

        let saveModal = {
            TableName: enumUtil.enumAPITableName.GetUserSalt,
            ID: props.userID + "",
            Data: { UserStatus: "Active", },

        }
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/DeActiveUser", 'post', saveModal).then((response) => {
            setIsLoading(false)
            setMainDeactiveModel(DeactiveUser_model)
            props?.FindByID(props.userID)
            props?.GridApi()
            NotificationHandler('User Successfully Activate!', enumUtil.enumtoaster.success)

        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }


    const handleCancel = () => {
        setMainDeactiveModel(DeactiveUser_model)
        setSaveDeactiveUser(DeactiveUser_model)
    }

    console.log(props?.DeActiveData, 'deActivedata');


    return (

        <>
            {isLoading ? <Loader /> : null}
            <div className=" za-deactivate_User za-exit-group w-100 ps-3">
                <div className='paragraph d-flex gap-1 mb-12 p-1'>
                    <i className='icon-Vector13 fs-16'></i>
                    <p className=' text'>When you deactivate a user account, the user can no longer log in or use the system. However, you can reactivate the account later if needed.</p>
                </div>
                {/* {props?.DeActiveData?.length > 0 ? null : */}

                {/* input_field-disable01 */}

                {props?.DeActiveData?.length > 0 ?
                    <div className='col-md-4  mb-2' >
                        <div className='form-group input'>
                            <label htmlFor="Date">Date</label>
                            <input type="text"
                                className='form-control'
                                // name="Description"
                                // id="Description"
                                // autoComplete="off"
                                value={props.DeActiveData?.[0]?.DeActiveDate}
                                // onChange={handlePOSChange}
                                disabled
                            />
                        </div>


                    </div>
                    :
                    <div className='col-md-4  mb-2'>
                        <div className={deactiveUserValidationModal.DeactiveDateVal ? 'form-group input error' : 'form-group input'}>
                            <DatePicker label='Date'
                                // value={props?.DeActiveData?.length > 0 ? props.DeActiveData?.[0]?.DeActiveDate : mainDeactiveUser?.DeActiveDate}
                                value={mainDeactiveUser?.DeActiveDate}
                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DeActiveDate')}
                            // isReadOnly={props?.DeActiveData?.length > 0 ? true : false}
                            />
                            {deactiveUserValidationModal.DeactiveDateVal}
                        </div>
                    </div>
                }




                {/* } */}


                <div className='col-md-4 form-group input mb-3'>
                    <div className={deactiveUserValidationModal.FullDescriptionVal ? 'form-group input error' : 'form-group input'}>
                        <label htmlFor="DeActiveComments">Comments</label>
                        <textarea type="text"
                            rows={4}
                            className='form-control'
                            name="DeActiveComments"
                            id="DeActiveComments"
                            autoComplete="off"
                            value={props?.DeActiveData?.length > 0 ? props?.DeActiveData?.[0]?.DeActiveComments : mainDeactiveUser.DeActiveComments}
                            onChange={handleChangeInput}
                            // readOnly={props?.DeActiveData?.length > 0 ? true : false}
                            disabled={props?.DeActiveData?.length > 0 ? true : false}
                        />
                        {deactiveUserValidationModal.FullDescriptionVal}
                    </div>
                </div>
                {props?.DeActiveData?.length > 0 ?
                    <div className="mb-3">
                        <button className='btn btn-greenn rounded btn-xs' onClick={() => handleActivateSave('')}>Activate</button>
                    </div>
                    :
                    <div className='d-flex gap-12 align-items-center mb-3'>
                        <button className='btn btn-gray rounded' onClick={handleCancel}>Cancel</button>
                        <button className='btn btn-danger rounded btn-xs' onClick={() => handleDeactiveSave('Deactive')}>Deactivate</button>
                    </div>}

            </div>
        </>
    )
}

export default DeactiveUser